import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import useAuth from "hooks/useAuth"

import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";

function ModalUpdateSell(props) {

    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const [sellsmanId, setSellsmanId] = useState(props.props.id_sellsman);
    const [br, setBR] = React.useState(false);
    const [sellsmans, setSellsmans] = useState([]);
    const [controlSnack, setControlSnack] = useState(false);

    const { storageId } = useAuth();

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        loadSellsman();
    }, []);

    async function loadSellsman() {
        const response = await api.get('sellsman/admin/type/all/' + storageId)
        setSellsmans(response.data);
    }

    async function handleEditSellsman(e) {
        e.preventDefault();
        const response = await api.put('client/update/sellsman/'+props.props.id,{
            id_sellsman: sellsmanId ? sellsmanId : sellsmans[0].id
        });

        if (response.status === 200) {
            setControlSnack(true);
            props.onHide();
            props.getAllClients();
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar Vendedor
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditSellsman}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridSellsman">
                            <Form.Label>Vendedores</Form.Label>
                            <Form.Control onChange={event => setSellsmanId(event.target.value)} value={sellsmanId} as="select" defaultValue="Choose...">
                                {sellsmans.map(sellsman => (
                                    <option key={String(sellsman.id)} value={sellsman.id}>{sellsman.name + " " + sellsman.lastname}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit" onClick={controlSnack ? () => showNotification("br") : () => showNotification("nf")}>
                            Editar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Vendedor modificado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateSell;